import callApi from '@/utils/callApi';
import { memoize } from '@gamifiera/array-cache';

export default memoize(async function () {
  const res = await callApi('GET', '/v1/avatar-slots');

  if (res.status !== 200) {
    throw new Error('Could not load slot data');
  }

  const slotData = await res.json();

  return slotData;
}, 600);
